import md5 from 'md5';
import { cdnImageDomain } from './config';

// 驼峰
export const toHump = (name, regType) => {
  let reg = /_(\w)/g;

  switch (regType) {
    case '-':
      reg = /-(\w)/g;
  }

  return name.replace(reg, function (all, letter) {
    return letter.toUpperCase();
  });
};

export const areEqual = (prev, next) => {
  return prev === next;
};

export const emptyFun = () => { };

export const getBase64 = file => {
  return new window.Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

export const randomNameUpload = fileName => {
  const index = fileName.lastIndexOf('.');
  const prefix = fileName.substring(0, index);
  const suffix = fileName.substring(index + 1);
  const key = md5(prefix + Math.random() * 1000) + '.' + suffix;

  return key;
};

export const urlSplit = url => {
  return url.split('/').reverse()[0];
};
export const comUrlSplit = url => url.split('com/').reverse()[0];

export const regMap = {
  twoDecimals: /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/,
  positiveInteger: /^[0-9]*[1-9][0-9]*$/,
  frontBackSpace: /^(?![ ]).*(?![ ]).$/,
  moreZero: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/,
};

export const antdRegRules = {
  twoDecimals: {
    pattern: regMap.twoDecimals,
    message: '最大可保留两位小数',
  },
  positiveInteger: {
    pattern: regMap.positiveInteger,
    message: '只能为正整数',
  },
  frontBackSpace: {
    pattern: regMap.frontBackSpace,
    message: '输入框前后不可为空格',
  },
  moreZero: {
    pattern: regMap.moreZero,
    message: '最小值大于0, 最多两位小数',
  },
};

export const uploadingWithdraw = (name, fileList, form) => {
  const files = fileList.map(item => {
    const { response = {} } = item;

    return response.key;
  });

  form.setFieldsValue({
    [name]: files,
  });
};

export const getFormItemLayout = (spanLabel, spanWrap) => ({
  labelCol: { span: spanLabel },
  wrapperCol: { span: spanWrap },
});

export const getRandomKey = () => {
  return Math.random().toString(36).substring(2, 7);
};

/**
 * 获取图片链接
 * @param {string} url 图片后缀地址，必须以 / 开头
 * @returns {string} 返回拼接好的 CDN 图片链接
 */
export const getImageUrl = url => {
  return `//${cdnImageDomain}${url}`;
};

/**
 * 加载图片
 * @param {string} url 图片链接
 * @returns {Promise<HTMLImageElement>} 图片对象
 */
export const loadImage = url => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve(image);
    image.onerror = err => reject(err);
    image.crossOrigin = 'anonymous';
    image.src = url;
  });
};

/**
 * 跳转到百度查询物流
 * @param {string} shippingCode 快递单号
 * @param {string} expressCode 快递公司代码
 * @param {string} [expressName] 快递公司名称
 */
export const searchLogistics = (shippingCode, expressCode, expressName = '') => {
  let wd = shippingCode;

  if (
    expressCode === 'ems' ||
    expressName.includes('邮政') ||
    expressName.includes('EMS') ||
    expressName.includes('ems')
  ) {
    wd = 'EMS' + shippingCode;
  }

  window.open('https://www.baidu.com/s?wd=' + encodeURIComponent(wd));
};
